<template>
  <ZNavigationDrawer
    v-model:mini="drawer"
    :router="routeList"
    :drawer-button="false"
    :rounded-overlay="true"
    :permissions="showPaths"
    theme="dark">
    <template #logo>
      <img :src="logo" class="icon" />
    </template>

    <template #listSecondary>
      <LeftBarStickedItems :items="items2" nav @selected-item-event="selectedItem"></LeftBarStickedItems>
    </template>
  </ZNavigationDrawer>
</template>

<script lang="ts" setup>
// Framework import
import { ref, computed } from 'vue'

import { storeToRefs } from 'pinia'

// Components import
import logo from '@/assets/icon.png'
import routeList from '@/router'

//Stores Import
// import FiltersStore from "@/stores/FiltersStore"

//Types import
import type Item from '@/types/Item'

//Assets import

//Utils Imports
// import { useQueryNavigation } from "@tsyl/vueabuse"
import AuthStore from '../stores/auth'

import LeftBarStickedItems from './LeftBarStickedItems.vue'

// Store Imports
// const filtersStore = FiltersStore()
// const { filtersOpen } = storeToRefs(filtersStore)

// Auth imports
const auth = AuthStore()
const { user, showUserAdminPanel } = storeToRefs(auth)
const showPaths = computed(() => {
  return user.value ? ['bookmarks'] : []
})
// const { removeQueryValue } = useQueryNavigation()

const drawer = ref(true)

const items2 = computed(() => {
  const items = [] as Array<Item>
  // if (auth.isAuthenticated()) {
  //   items.push({
  //     icon: "mdi-tune",
  //     title: "common.actions.filter",
  //     value: "m",
  //     onclick: function () {
  //       goToFilter()
  //     },
  //   })
  // }
  if (auth.hasPermission('admin-users')) {
    items.push({
      icon: 'mdi-account-group',
      title: 'views.userAdmin.menu',
      value: 'i',
      onclick: function () {
        showUserAdminPanel.value = !showUserAdminPanel.value
      }
    })
  }
  return items
})

function selectedItem(item: Item) {
  item.onclick()
}

// function goToFilter() {
//   removeQueryValue(["incident"])
//   filtersOpen.value = true
// }
</script>

<style lang="scss">
.left_bar > .v-navigation-drawer__content {
  background-color: rgb(var(--v-theme-surface-light)) !important;
  display: flex;
  flex-direction: column;
}

.left_bar > .v-navigation-drawer__append {
  display: flex;
}

.left_bar > .v-navigation-drawer__content > .v-list > .v-list-item--active > .v-list-item__prepend {
  color: rgb(var(--v-theme-primary));
}

.left_bar > .v-navigation-drawer__content > .v-list > .v-list-item--active > .v-list-item__overlay {
  opacity: 1;
}

.left_bar > .v-navigation-drawer__content > .v-list > .v-list-item > .v-list-item__overlay {
  padding-right: 4em;
  background-color: rgb(var(--v-theme-surface));
}

[data-v-onboarding-wrapper] [data-popper-arrow]::before {
  content: '';
  background: var(--v-onboarding-step-arrow-background, white);
  top: 0;
  left: 0;
  transition:
    transform 0.2s ease-out,
    visibility 0.2s ease-out;
  visibility: visible;
  transform: translateX(0px) rotate(45deg);
  transform-origin: center;
  width: var(--v-onboarding-step-arrow-size, 10px);
  height: var(--v-onboarding-step-arrow-size, 10px);
  position: absolute;
  z-index: -1;
}

[data-v-onboarding-wrapper] [data-popper-placement^='top'] > [data-popper-arrow] {
  bottom: 5px;
}

[data-v-onboarding-wrapper] [data-popper-placement^='right'] > [data-popper-arrow] {
  left: -4px;
}

[data-v-onboarding-wrapper] [data-popper-placement^='bottom'] > [data-popper-arrow] {
  top: -4px;
}

[data-v-onboarding-wrapper] [data-popper-placement^='left'] > [data-popper-arrow] {
  right: -4px;
}
</style>

<style scoped lang="scss">
.icon {
  width: 30px;
}

.user_button {
  background-color: rgb(var(--v-theme-surface));
  border-radius: 50%;
  height: 40px;
  width: 40px;
}
</style>
